import React from "react";
import HourglassEmptyRoundedIcon from "@mui/icons-material/HourglassEmptyRounded";

const DropdownMenu = ({ dropdownObject, handleDropdownChange }) => (
  <>
    <HourglassEmptyRoundedIcon
      className="ml-1 shrink-0 text-text-muted 2xl:hidden"
      sx={{ fontSize: 16 }}
      titleAccess="Set expiry"
    />
    <p className="hidden shrink-0 whitespace-nowrap font-montserrat text-xs italic text-text-muted 2xl:block">
      Set Expiry to{" "}
    </p>
    <select
      aria-label="Set expiry"
      onChange={handleDropdownChange}
      className="mr-1 shrink-0 cursor-pointer bg-transparent p-1 font-montserrat text-sm font-semibold text-text focus:outline-none"
    >
      {dropdownObject.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  </>
);

export default DropdownMenu;
